import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/**
 * Gates `/app/*` (excluding /app/onboarding) so users without a completed
 * household profile are routed into the onboarding flow first.
 */
export default function RequireOnboarded({ children }) {
  const location = useLocation();
  const { user } = useAuth();

  if (user === undefined) return null; // parent RequireAuth already shows a loader

  // Members joining an existing household don't need onboarding — they inherit the household profile.
  const isJoinedMember = !!user?.household_owner_id;
  const onboardingComplete = user?.profile_complete || isJoinedMember;

  if (user && !onboardingComplete && !location.pathname.startsWith("/app/onboarding")) {
    return <Navigate to="/app/onboarding" replace />;
  }
  return children;
}
